// extracted by mini-css-extract-plugin
export default {"tooltipBlock":"style_tooltipBlock__Jp484","header":"style_header__CdRKy","tooltipBlockContent":"style_tooltipBlockContent__b69fg"};